import { MessageService } from 'primeng/api';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { BarcodeFormat } from '@zxing/library';
import { BehaviorSubject } from 'rxjs';
import { ProductAuthService } from './../../services/product-auth.service';
import { LoginService } from 'src/app/services/login.service';
import { ProductAuthRequest, ProductAuthResponse, ProductRating, ProductRatingResponse, GetUserVerificationResponse, GetUserVerification } from 'src/app/models/productAuth';
import { ProductMasterResponse, ProductMaster } from '../../models/Masters/productMaster';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-hi-product-authentication',
  templateUrl: './hi-product-authentication.component.html',
  styleUrls: ['./hi-product-authentication.component.css']
})
export class HIProductAuthenticationComponent implements OnInit {
  productAuthRequests: ProductAuthRequest = new ProductAuthRequest();
  prodDetails: ProductAuthResponse = new ProductAuthResponse();
  constructor(private fb: FormBuilder, private messageService: MessageService, private loginService: LoginService,
    private prodAuthService: ProductAuthService, public sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.productAuthRequests.verificationMode = 'Web';
    this.productAuthRequests.qrData = window.location.href;
    this.productAuthRequests.verificationType = 2;
    this.findMe();  // find location
  }

  sendProductAuthData(value: any) {
    this.prodAuthService.hiProductAuthData(value).subscribe((productAuthResponse: ProductAuthResponse) => {
      this.prodDetails = productAuthResponse;  
      console.log(productAuthResponse);   
      if (productAuthResponse.responseCode === '200') {
        const verificationHistories = localStorage.verificationHistories ? JSON.parse(localStorage.verificationHistories) : [];
        verificationHistories.push({ verificationId: this.prodDetails.data.verificationId, usrId: this.loginService.user() });
        localStorage.verificationHistories = JSON.stringify(verificationHistories);        
      } else {
        
      }

    }, err => {

    });
  }

  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      }, (denied) => {
        // alert(JSON.stringify(denied));
        this.sendProductAuthData(this.productAuthRequests);
      }, { enableHighAccuracy: true, maximumAge: 10000 });
    } else {
      this.sendProductAuthData(this.prodAuthService);
    }
  }
  showPosition(position) {
    this.productAuthRequests.usrlatitude = position.coords.latitude;
    this.productAuthRequests.usrlongitude = position.coords.longitude;
    this.reverseGeocodeLatLngAndVerifyProduct();
  }
  reverseGeocodeLatLngAndVerifyProduct(): any {
    // tslint:disable-next-line: max-line-length
    this.prodAuthService.reverseGeoCode(this.productAuthRequests.usrlatitude, this.productAuthRequests.usrlongitude).subscribe((response: any) => {
      this.productAuthRequests.usrAdrs = response.display_name;
      this.productAuthRequests.usrCity = response.address.city;
      this.productAuthRequests.usrCntry = response.address.country;
      this.productAuthRequests.usrState = response.address.state;
      this.productAuthRequests.usrZip = response.address.postcode;
      this.sendProductAuthData(this.productAuthRequests);

    }, error => {
      // alert(JSON.stringify(error))
      this.sendProductAuthData(this.productAuthRequests);
    });
  }
}
